function Inbox() {
  return (
    <div>
      <h1>Posteingang</h1>
    </div>
  );
}

export default Inbox;
